import { useDialog } from "@hooks";

export const useAlertDialog = () => {
  const { alertDialog } = useDialog();

  return { alertDialog };
};
